module.exports = __webpack_public_path__ + "img/Assistant.2ce87a6a.jpg";